import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'

import Icon from 'discada/dist/Icon'

import Menuing from 'components/widgets/Menuing'
import { toggleRebate } from 'actions/quoteActions'
import { money } from 'utils'
import {
  getRebatesForVehicle,
  getMaxRebateValue,
  getQuoteValue,
  getOptionCodeSet,
} from 'selectors/quoteSelectors'
import { DealerCashUsage } from 'components/Settings/Bank.js'
import {
  changeQuote,
  setRebateValue,
  toggleOptionCode,
} from 'actions/quoteActions'

import { addToPageState } from 'actions/pageStateActions'

import QV from 'components/Quote/QuoteValue'
import SimpleRebates from 'components/Quote/SimpleRebates'

import './Rebates.scss'

export class Rebates extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      showAll: this.props.hideDisclaimer || this.props.getDealerCash,
    }

    this.toggleShowAll = () => this.setState({ showAll: !this.state.showAll })
  }

  render() {
    let {
        vehicleId,
        quoteId,
        displayRebates,
        getDealerCash,
        toggleRebate,
        dealerIncentivesReducePrice,
        paidReserveReducesPrice,
        changeQuote,
        setRebateValue,
        selectedRebateValues,
        optionCodes,
        toggleOptionCode,
        selectedOptionCodes,
        hideDisclaimer,
        addToPageState,
      } = this.props,
      { showAll } = this.state

    return (
      <section className={c('quote-rebates')}>
        {!getDealerCash && (
          <F>
            <SimpleRebates vehicleId={vehicleId} quoteId={quoteId} showAll />

            {!hideDisclaimer && (
              <p className="rebate-disclaimer">
                Your dealer is the ultimate authority on which incentives will
                apply. Here are a few that may apply.
                <br />
                Select all that you think you qualify for. We will apply them in
                the best way possible.
              </p>
            )}
          </F>
        )}

        {!getDealerCash && !isEmpty(optionCodes) && (
          <div>
            <h4>Available Option Codes</h4>
            {Object.keys(optionCodes).map(k => (
              <span
                key={k}
                onClick={() => toggleOptionCode(vehicleId, quoteId, k)}
                className="option-code-choice"
              >
                <Icon
                  prefix="fal"
                  icon={
                    selectedOptionCodes.includes(k) ? 'check-square' : 'square'
                  }
                />{' '}
                {k}{' '}
              </span>
            ))}
            <br />
            <br />
          </div>
        )}

        {getDealerCash && (
          <header>
            <h3 className="inline">Dealer Cash</h3>
            <DealerCashUsage
              label="Use Dealer Cash to Reduce Price"
              checked={dealerIncentivesReducePrice}
              onChange={() =>
                changeQuote(
                  vehicleId,
                  quoteId,
                  { dealerIncentivesReducePrice: !dealerIncentivesReducePrice },
                  { dirty: true },
                )
              }
            />
            <DealerCashUsage
              label="Use Paid Reserve to Reduce Price"
              checked={paidReserveReducesPrice}
              onChange={() =>
                changeQuote(
                  vehicleId,
                  quoteId,
                  { paidReserveReducesPrice: !paidReserveReducesPrice },
                  { dirty: true },
                )
              }
            />
            <br />
          </header>
        )}

        <h4>
          {showAll ? 'All Available' : 'Selected'} Incentives
          {!hideDisclaimer && !getDealerCash && (
            <small onClick={this.toggleShowAll} className="show-all-toggle">
              {showAll
                ? 'Show only selected Incentives'
                : 'Show all Incentives'}
            </small>
          )}
        </h4>

        <Menuing
          items={displayRebates.filter(r => showAll || r.Selected)}
          labelRenderer={r => (
            <div
              className="rebate-label"
              onClick={() =>
                !r.AvailableToAll && toggleRebate(vehicleId, quoteId, r.ID)
              }
            >
              <span className="rebate-selector">
                <Icon
                  prefix="fal"
                  className={r.AvailableToAll ? 'disabled' : ''}
                  icon={
                    r.AvailableToAll
                      ? 'check-square'
                      : r.Selected
                      ? 'check-square'
                      : 'square'
                  }
                />
              </span>

              <span className="rebate-description">
                <span className="rebate-name">
                  {r.Name || r.NameDisplay}{' '}
                  <span className="rebate-number">{r.Number}</span>
                </span>
                For{' '}
                <strong>
                  {r.TransactionType === 'any' ? 'All' : r.TransactionType}{' '}
                  programs
                </strong>
                {!isEmpty(r.compats) && (
                  <F>
                    , compatible with <strong>{r.compats.join(', ')}</strong>
                  </F>
                )}{' '}
                {r.StopDate && (
                  <span className="rebate-dates">
                    <br />
                    Through {moment(r.StopDate).format('LL')}, (revised{' '}
                    {moment(r.RevisionDate).format('LL')})
                  </span>
                )}{' '}
                <span
                  className="rebate-details-link"
                  onClick={e => {
                    addToPageState({ rebateDetails: r.ID })
                    e.stopPropagation()
                    return false
                  }}
                >
                  See Details
                </span>
              </span>
            </div>
          )}
          valueRenderer={r => {
            let val = getMaxRebateValue(r),
              displayVal = typeof val === 'number' ? money(val) : val

            if (r.ManualValueInputRequired) {
              return (
                <QV
                  id={quoteId}
                  vehicleId={vehicleId}
                  value={get(selectedRebateValues, r.ID, 0)}
                  type="money"
                  permit="profit"
                  onChange={v => setRebateValue(vehicleId, quoteId, r.ID, v)}
                />
              )
            }

            return val > 0 ? (
              <span className="rebate-value">Up to {displayVal}</span>
            ) : (
              <span className="rebate-value varies">
                See Summary for Details
              </span>
            )
          }}
        />
      </section>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    displayRebates: sortBy(
      getRebatesForVehicle(state, op.vehicleId, op.quoteId, op.mode, {
        customer: !op.getDealerCash,
        dealer: !!op.getDealerCash,
      }),
      r => r.Name,
    ),
    dealerIncentivesReducePrice: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'dealerIncentivesReducePrice',
      false,
    ),
    paidReserveReducesPrice: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'paidReserveReducesPrice',
      false,
    ),
    selectedRebateValues: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'selectedRebateValues',
      {},
    ),
    optionCodes: getOptionCodeSet(state, op.vehicleId, op.quoteId).reduce(
      (ret, o) => ({ ...ret, [o]: o }),
      {},
    ),
    selectedOptionCodes: (
      getQuoteValue(state, op.vehicleId, op.quoteId, 'vehicleOptionCode', '') ||
      ''
    ).split(','),
  }
}

export default connect(
  mapStateToProps,
  {
    toggleRebate,
    changeQuote,
    setRebateValue,
    toggleOptionCode,
    addToPageState,
  },
)(Rebates)
